import type { MarketVariants } from '@/lib/i18n'

export type Slide15Copy = {
  completionTitle: string
  body: string
  buttonLabel: string
}

export const copy: MarketVariants<Slide15Copy> = {
  US: {
    completionTitle: 'Chapter 1 complete',
    body: "Now that you know how modern scams work, the next chapter covers the emotional tricks scammers use to catch people off guard.",
    buttonLabel: 'Continue to Chapter 2',
  },
  ar: {
    completionTitle: 'اكتمل الفصل 1',
    body: 'الآن وقد عرفت كيف يعمل الاحتيال الحديث، يتناول الفصل التالي الحيل العاطفية التي يستخدمها المحتالون لمباغتة الناس.',
    buttonLabel: 'المتابعة إلى الفصل 2',
  },
}
